import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Loading from '../../Common/components/Loading';
import useGallery from '../../Gallery/components/hooks/useGallery';

export default function ShareLanding() {
    const { galleryId } = useParams();
    const [isLoading, setIsLoading] = useState(true);

    const { getGalleryById } = useGallery({
        galleryId: galleryId ? +galleryId : 0,
        slug: '',
    });

    useEffect(() => {
        let isMounted = true;

        const getGalleryInfo = async () => {
            try {
                const galleryInfo = await getGalleryById();

                if (galleryInfo?.baseUrl) {
                    window.location.href = `${galleryInfo.baseUrl}${window.location.pathname}${window.location.search}`;
                }
            } catch (e) {
                console.error(e);
            } finally {
                isMounted && setIsLoading(false);
            }
        };

        getGalleryInfo();

        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) {
        return <Loading isLoading={true} />;
    }

    return null;
}
